import { Link } from 'react-router-dom';
export default function Pricing() {
  return <section id="pricing" className="studio-scope"><div className="studio-shell scope-layout">
    <h2>Start with one process.</h2>
    <p className="scope-description">Pick a task your team repeats often. We will review the work involved and quote for that scope, including software charges and any ongoing support.</p>
    <Link to="/#request-demo" className="scope-link">Request a demo</Link>
  </div></section>;
}
